import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getWebsiteSettingData } from '../../../Redux/action/MasterAction'
import { useFormik } from "formik";
import toast, { Toaster } from 'react-hot-toast';

import axios from 'axios';
import { FocusError } from 'focus-formik-error';
import * as Yup from "yup";
import '../../HomePage/Footer/scss/common.css'
const host = process.env.REACT_APP_API_SERVER
const StudentFooter = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getWebsiteSettingData());
    }, [])

    const {
        loadingWebsiteSettingDataListApi,
        WebsiteSettingDataListApiData,
        WebsiteSettingDataListApiError

    } = useSelector(state => state?.MasterReducer);
    let [initialValues, setInitialValues] = useState({

        email: "",

    })

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({

            email: Yup.string().required("Email is required.").matches(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/, "Enter a valid E-mail"),

        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true)
            try {






                await axios.post(`${host}/api/web/newsletter`, values)
                    .then(function (response) {
                        if (response.status == 200) {
                            setSubmitting(false)

                            toast.success("Form Submitted Succesfully");

                            resetForm()
                        } else {

                            setSubmitting(false)

                            toast.error(response.data.msg);

                            resetForm()
                        }
                    })
                    .catch(function (error) {


                        setSubmitting(false)
                        toast.error('Error submitting form. Please try again.');

                        resetForm()
                    })

            }
            catch (error) {


                setSubmitting(false)
                toast.error('Error submitting form. Please try again.');

                resetForm()
            }

        }
    })
    return (
        <footer className="footer-wrap" id="cont">
           
            <>
                <section className='footer-parent-sec'>
                    <div className='container'>
                        <div className='row align-items-center-md'>
                            <div className='col-lg-5 col-md-6 col-12'>
                                <div className='ft-left-dv'>
                                    <a href="/" className="footer-logo text-center">
                                        <img
                                            src="/website/assets/img/logo.png"
                                            alt="Image"
                                            style={{ maxHeight: 64 }}
                                        />
                                    </a>
                                    <div className='ft-after-logo'>
                                        <div className='ft-a-tag'>
                                            <a href="https://docs.google.com/forms/d/17wnWQkio6nE9hiSQJXwEP82eh6D6s9jmlpi3VXgLxyY/viewform?pli=1&ts=66ef841a&pli=1&edit_requested=true" target="_blank">
                                                Feedback</a>
                                            <Link to="/privacy-policy">Privacy Policy</Link>
                                            <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
                                        </div>
                                        <div className='ft-a-tag-2'>
                                            <span>E-mail - </span><a href={`mailto:${WebsiteSettingDataListApiData?.email}?subject=Support Request`} className=''>{WebsiteSettingDataListApiData?.email}</a>
                                        </div>
                                        <div className='ft-a-tag-2'>
                                            <span>Phone - </span><a href={`tel:${WebsiteSettingDataListApiData?.mobile}`}>{WebsiteSettingDataListApiData?.mobile}</a>
                                        </div>
                                        <div className='ft-a-tag border-bottom-none'>
                                            <Link to={WebsiteSettingDataListApiData?.instagram_link} target='_blank'>
                                                <i
                                                    className="fa-brands fa-square-instagram"
                                                    data-toggel="tooltip"
                                                    title="Instagram"
                                                />
                                            </Link>
                                            <Link to={WebsiteSettingDataListApiData?.facebook_link} target='_blank'>
                                                <i
                                                    className="fa-brands fa-facebook"
                                                    data-toggel="tooltip"
                                                    title="Facebook"
                                                />
                                            </Link>
                                            <Link to={WebsiteSettingDataListApiData?.linkedin_link} target='_blank'>
                                                <i
                                                    className="fa-brands fa-linkedin"
                                                    data-toggel="tooltip"
                                                    title="LinkedIn"
                                                />
                                            </Link>
                                            <Link to={WebsiteSettingDataListApiData?.twitter_link} target='_blank'>
                                                <i
                                                    className="fa-brands fa-square-x-twitter"
                                                    data-toggel="tooltip"
                                                    title="Twitter"
                                                />
                                            </Link>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-2 d-md-none d-lg-block d-block'></div>

                            <div className='col-lg-5 col-md-6 col-12'>
                                <form method='post' onSubmit={formik.handleSubmit}>
                                    <div className='ft-rt-dv'>
                                        <div className='d-flex flex-column flex-wrap justify-content-center align-content-center align-item-center inner-img-dv mb-5'>
                                            {/* <div className='col-xl-6 col-lg-4 col-md-12 col-12 inner-img'> */}
                                                <img src='/assets/img/user/ft-right.png' className='img-fluid' />
                                            {/* </div>
                                            <div className='col-xl-6 col-lg-8 col-md-12 col-12 right-img-dv'> */}
                                                <h4 className='text-white mb-0 pb-0'>Get our weekly</h4>
                                                <h3 className='my-0 py-0 text-white'>Newsletter</h3>
                                                <p className='text-center mt-0 pt-0 text-white'>Join our newsletter and receive a weekly update of the top job openings directly in your inbox. Subscribe now!</p>
                                            {/* </div> */}
                                        </div>
                                        <div className='ft-input mt-2'>
                                            <input type='text' name='email' placeholder='Email Address'
                                             className='ps-2'
                                                maxLength={50}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.email} />
                                            <button type='submit' disabled={formik.isSubmitting}>Subscribe</button>
                                            <div className="help-block with-errors">
                                                {formik.touched.email && formik.errors.email ? (
                                                    <div className='text-danger'>{formik.errors.email}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </section>
                <section className='bottom-st-section'>
                    <div className='bottom-strip-head'>
                        <div className='bottom-strip'>
                            <div className='container'>
                                <div className='row'>
                                    <div className="col-lg-12 col-md-12 col-12 order-lg-1 order-md-2 order-2 d-flex justify-content-center">
                                        <p className="copyright">
                                            <span className="las la-copyright" />
                                            <a className='fw-bold text-white'>SEEK2LRN</a> All Rights Reserved. Designed By{" "}
                                            <a className='fw-bold text-white'>Seek2learn</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </>
        </footer>

    )
}

export default StudentFooter